
import ResourceCard from "./ResourceCard";
import { Cloud, Bell, FileCode, CheckSquare, ClipboardList, Key } from "lucide-react";
import { useGridColumns } from "@/hooks/use-grid-columns";
import { useEffect } from "react";

interface ResourceGridProps {
  onCardClick: (id: string) => void;
}

const ResourceGrid = ({ onCardClick }: ResourceGridProps) => {
  const columns = useGridColumns();
  
  const resourceCards = [
    {
      id: "integrations",
      title: "CIPP Integrations",
      description: "Connect your CIPP instance with other tools and services",
      icon: <Cloud />,
    },
    {
      id: "alerts",
      title: "Security Alerts",
      description: "Configurable security notifications for your environment",
      icon: <Bell />,
    },
    {
      id: "presets",
      title: "Graph API Presets",
      description: "Ready-to-use Graph API queries for common data needs",
      icon: <FileCode />,
    },
    {
      id: "standards",
      title: "Security Standards",
      description: "Industry security standards and best practices implementations",
      icon: <CheckSquare />,
    },
    {
      id: "bpa",
      title: "BPA Templates",
      description: "Best Practice Assessment templates for environment evaluation",
      icon: <ClipboardList />,
    },
    {
      id: "licenses",
      title: "License Helper",
      description: "Search and explore Microsoft 365 licenses and service plans",
      icon: <Key />,
    },
  ];

  // Calculate if we have an incomplete last row to distribute cards evenly
  const cardsCount = resourceCards.length;
  const hasIncompleteRow = cardsCount % columns !== 0;
  
  // Add custom CSS for centering the incomplete last row
  useEffect(() => {
    // Create a style element
    const styleEl = document.createElement('style');
    
    // Define the CSS for centering the incomplete last row
    const css = `
      @media (min-width: 1024px) {
        .grid-cols-3 > *:nth-last-child(2):nth-child(3n-1),
        .grid-cols-3 > *:nth-last-child(1):nth-child(3n-2) {
          grid-column: span 1;
        }
        
        /* Center the last two items when there are only 5 items total */
        .grid-cols-3 > *:nth-child(4):nth-last-child(2),
        .grid-cols-3 > *:nth-child(5):nth-last-child(1) {
          margin-left: auto;
          margin-right: auto;
        }
      }
    `;
    
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
    
    // Clean up the style element when the component unmounts
    return () => {
      document.head.removeChild(styleEl);
    };
  }, []);
  
  return (
    <div className="container mx-auto px-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {resourceCards.map((card) => (
          <ResourceCard
            key={card.id}
            id={card.id}
            title={card.title}
            description={card.description}
            icon={card.icon}
            onClick={onCardClick}
          />
        ))}
      </div>
    </div>
  );
};

export default ResourceGrid;
